define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
  'es6!launcher/data/countries',
], (React, PropTypes, Immutable, _, Util, Component, Countries, Constants) => {
  const { classNames } = Util;

  const PRESET_OPTIONS = {
    'country': Countries.immutableOptions,
  };

  const VALID_STYLE_ATTRS = [
    'color',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
  ];

  @Component({ disableVerticalResize: true })
  class Dropdown extends React.Component {
    static propTypes = {
      placeholder: PropTypes.string,
      options: PropTypes.object,
      style: PropTypes.object,
      onSaveInputField: PropTypes.func,
      disabled: PropTypes.bool,
    };

    static defaultProps = {
      style: Immutable.Map(),
      disabled: false,
    }

    constructor(props) {
      super(props);

      this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
      const { name, onChangeForm } = this.props;

      if (onChangeForm) onChangeForm({ [name]: e.currentTarget.value });
    }

    renderOptions() {
      const { name, placeholder, disabled } = this.props;
      const optionsComponents = [];

      let { options } = this.props;
      if (PRESET_OPTIONS.hasOwnProperty(name)) {
        options = PRESET_OPTIONS[name];
      }

      optionsComponents.push(
        <option
          key='placeholder'
          value="placeholder"
          disabled
        >
          {placeholder}
        </option>
      );

      options.forEach(option => {
        optionsComponents.push(
          <option
            key={option.get('id')}
            value={option.get('value')}
          >
            {option.get('label')}
          </option>
        );
      });

      return optionsComponents;
    }

    render() {
      const {
        placeholder,
        defaultValue,
        boxShadowStyle,
        isPreview,
        onSaveInputField,
        onFocus,
        onBlur,
        onMouseEnter,
        onMouseLeave,
        disabled,
      } = this.props;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);
      style.padding = '0';
      style.margin = '0';
      style.display = 'block';
      style.width = '100%';

      const containerStyle = _.extend(style, {
        position: 'relative',
        overflow: 'hidden',
        zIndex: 0,
        boxShadow: boxShadowStyle.boxShadow,
      });

      const selectStyle = {
        height: 'auto',
        width: '100%',
        margin: '0',
        padding: '14px',
        border: 'none',
        color: this.props.style.get('color'),
        background: this.props.style.get('background'),
        backgroundColor: this.props.style.get('backgroundColor'),
        textShadow: this.props.style.get('textShadow'),
        boxShadow: boxShadowStyle.insetBoxShadow,
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        fontStyle: 'inherit',
      };

      const className = classNames({
        "sumome-react-wysiwyg-overlay": isPreview,
        "sumome-react-wysiwyg-component-wrapper": true,
      });

      // .sumome-react-wysiwyg-select-overlay adds an :after psuedo element
      // overlay so we can bypass dropdown clicking and still select components.
      return (
        <div
          className={className}
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          ref={(el) => this.textEl = el}
        >
          <select
            ref={onSaveInputField}
            style={selectStyle}
            disabled={isPreview || disabled}
            defaultValue={defaultValue || 'placeholder'}
            onChange={this.onChange}
            onFocus={onFocus}
            onBlur={onBlur}
          >
            {this.renderOptions()}
          </select>
        </div>
      );
    }
  }

  return Dropdown;
});
